import { widget } from "@foretagsplatsen/widgetjs";

/**
 * Displays a user avatar.
 *
 * @param {{}} spec - Parameter object
 * @param {user} spec.user - User to display
 * @param {{}} my - protected fields holder
 * @return {*}
 */
function userAvatarWidget(spec, my) {
	spec ||= {};
	my ||= {};

	const user = spec.user;
	const that = widget(spec, my);

	that.onClick = my.events.createEvent();

	that.renderOn = function (html) {
		html.div(
			{ id: that.getId(), class: "avatar-icon" },
			html.div(
				{ class: "consultant admin-comp-popover" },
				html
					.img({
						class: "user-picture",
						src: user.getPictureUrl(),
					})
					.click(() => {
						that.onClick.trigger(user);
					}),
				html.p(user.getName()),
			),
		);
	};

	return that;
}

export default userAvatarWidget;
